import React from 'react';
import UserProvider from './src/containers/user-provider';

export const wrapRootElement = ({element}) => {
  return (
    <UserProvider>
      {element}
    </UserProvider>
  )
}